import { render, staticRenderFns } from "./CommunityDevelopmentView.vue?vue&type=template&id=73b6e50b&scoped=true"
import script from "./CommunityDevelopmentView.vue?vue&type=script&lang=ts"
export * from "./CommunityDevelopmentView.vue?vue&type=script&lang=ts"
import style0 from "./CommunityDevelopmentView.vue?vue&type=style&index=0&id=73b6e50b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6e50b",
  null
  
)

export default component.exports